import { render, staticRenderFns } from "./bmi.vue?vue&type=template&id=12f55c0c&scoped=true&"
import script from "./bmi.vue?vue&type=script&lang=js&"
export * from "./bmi.vue?vue&type=script&lang=js&"
import style0 from "./bmi.vue?vue&type=style&index=0&id=12f55c0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f55c0c",
  null
  
)

export default component.exports